let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gZpYg")).then(() => parcelRequire('1pDJK'));